import React from "react"
import { useHistory } from "react-router-dom";

import { Badge } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";

import {
  Avatar,
  Box,
  Button,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Tooltip,
} from "@mui/material"

import { huntInfos } from "sessions/resources/hunts.js";
import { dataCenters } from "sessions/resources/datacenters";
import { SessionConfigs } from "sessions/sessionState";
import TablePagination from "../Pagination/Pagination.js";
import LanguageDependentText from "components/TimerTable/LanguageDependentText.js";

function HistoryTable({data, admin, children}) {
  const history = useHistory();

  const viewPerPage = 20;
  const [alert, setAlert] = React.useState(null);
  const [displayData, setDisplayData] = React.useState([]);
  const [paginationControl, setPagination] = React.useState({
    currentPage: 0,
    totalPages: 0
  });

  React.useEffect(() => {
    data.sort((a,b) => new Date(b.deathTime) - new Date(a.deathTime));
    setPagination({currentPage: 0, totalPages: Math.ceil(data.length / viewPerPage)});
  }, [data])

  React.useEffect(() => {
    setDisplayData(data.slice(paginationControl.currentPage * viewPerPage, paginationControl.currentPage * viewPerPage + viewPerPage));
  }, [paginationControl])

  const textLibrary = SessionConfigs.dictionaryLookup;
  const allWorlds = dataCenters[SessionConfigs.getDataCenter()]["Names"];

  const showRevertWarning = (huntName, worldName, deathTime, id) => {
    setAlert(
      <SweetAlert
          warning style={{display: "block",marginTop: "-100px"}}
          title={SessionConfigs.dictionaryLookup("header", "historyRevertRequest")} onConfirm={() => handleSubmitRevertRequest(huntName, worldName, deathTime, id)}
          onCancel={() => setAlert(null)} confirmBtnBsStyle="danger" showCancel cancelBtnBsStyle="default">
      </SweetAlert>
    );
  };

  const handleSubmitRevertRequest = (huntName, worldName, deathTime, id) => {
    setAlert(null);
    SessionConfigs.queryData("/api/revertRequest", {
      "HuntName": huntName,
      "WorldName": worldName,
      "DeathTime": deathTime,
      "ID": id,
    }).then(() => {
      setAlert(<SweetAlert
        success style={{display: "block",marginTop: "-100px"}}
        title={SessionConfigs.dictionaryLookup("header", "historyRevertRequestSuccess")} onConfirm={() => setAlert(null)}
        onCancel={() => setAlert(null)} confirmBtnBsStyle="info" >
      </SweetAlert>);
    }).catch((error) => {
      SessionConfigs.displayError(error, setAlert);
    });
  }
  
  return (
    <>
      {alert}
      <Table size="large">
        <TableHead>
          <TableRow>
          {["tableHuntName", "tableWorldName", "historyDeadTime", "historyReporter", "historyRevert"].map((col) => {
            if (!admin && col=="historyRevert") return;

            return (
              <TableCell key={col} variant="head" style={{width: col == "tableWorldName" ? "20%" : "25%", verticalAlign: "bottom", paddingBottom: 0, paddingTop: 0}}>
                <LanguageDependentText variant="span" header={col} fontSize={12} fontWeight={"bold"} color="#111111" style={{cursor: "pointer"}} onClick={()=>console.log({col})}/>
              </TableCell>
          )})}
          </TableRow>
        </TableHead>
        <TableBody>
          {displayData.map((hunt) => {
            const badgeColorID = allWorlds.indexOf(hunt.worldName);
            var baseName = hunt.huntName;
            if (baseName.endsWith(" 1") || baseName.endsWith(" 2") || baseName.endsWith(" 3") || baseName.endsWith(" 4") || baseName.endsWith(" 5") || baseName.endsWith(" 6") || baseName.endsWith(" 7") || baseName.endsWith(" 8")) {
              baseName = baseName.slice(0,-2);
            }
            return <TableRow key={hunt.id}>
              <TableCell>
                <Box sx={{display: "flex", flexDirection: "row"}}>
                  <IconButton sx={{ width: 24, height: 24, marginRight: "2px" }}>
                    <Avatar src={Object.keys(huntInfos).includes(baseName) ? require("assets/images/HuntIcons/" + baseName + ".png") : require("assets/images/HuntIcons/" + "temp" + ".png")} sx={{ width: 24, height: 24 }}/>
                  </IconButton>
                  <Box paddingBottom={0} paddingLeft={2} sx={{display: "flex", flexDirection: "column", justifyContent: "space-evenly"}}>
                    <LanguageDependentText variant="span" huntName={hunt.huntName} fontSize={15}/>
                  </Box>
                </Box>
              </TableCell>
              <TableCell>
                <Badge as="<label>" className={"world-badge " + `world-color-${badgeColorID}`}>
                  <LanguageDependentText variant="span" fontSize={12} align={"center"}>
                    {hunt.worldName.length > 5 ? hunt.worldName.slice(0,4) : hunt.worldName}
                  </LanguageDependentText>
                </Badge>
              </TableCell>
              <TableCell>
                <LanguageDependentText variant="span" date={new Date(hunt.deathTime)} fontSize={15}> {hunt.missing ? "(" + textLibrary("header", "tableMissing") + ")" : null} </LanguageDependentText>
              </TableCell>
              <TableCell>
                {hunt.isMaint ? <LanguageDependentText variant="span" header={"historyMaint"} fontSize={15}/> : <LanguageDependentText variant="span" text={hunt.reporter} fontSize={15}/>}
              </TableCell>
              {admin ? (
              <TableCell>
                <Button variant="contained" color="error" onClick={() => showRevertWarning(hunt.huntName, hunt.worldName, hunt.lastDeathTime, hunt.id)}>
                  {SessionConfigs.dictionaryLookup("header", "historyRevert")}
                </Button>
              </TableCell>
              ) : null}
            </TableRow>
          })}
        </TableBody>
      </Table>
      <TablePagination totalPages={paginationControl.totalPages} currentPage={paginationControl.currentPage} setPagination={setPagination} />
    </>
  );
}

export default HistoryTable;